import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@rsos/base-components';
import { cspAudioOrgSettingsSelector } from '@rsos/reduxDataStore/src/features/selectors/cspOrgSettingsSelectors';
import { patchOrgAttributes } from '@rsos/sinatra';
import { notifyError } from '@rsos/utils/toastUtils';
import SoundControlCard from '../SoundControlCard';
import {
  SoundControlTitle,
  SoundControlDescription,
} from './SoundControl.styles.js';

const ALERTS = 'alerts';
const AUDIO_SETTINGS = 'audio_settings';

const SoundControl = () => {
  const dispatch = useDispatch();
  const orgID = useSelector(state => state.sinatra.user.currentOrg.id);
  const applicationName = useSelector(
    state => state.sinatra.user.currentRole.application,
  );
  const orgAudioSettings = useSelector(state =>
    cspAudioOrgSettingsSelector(state.sinatra),
  );

  const updateAudioSettings = setting => {
    const updatedSettings = {
      [AUDIO_SETTINGS]: {
        ...orgAudioSettings,
        [ALERTS]: { ...orgAudioSettings[ALERTS], ...setting },
      },
    };

    dispatch(patchOrgAttributes(orgID, applicationName, updatedSettings)).catch(
      e => {
        const message = e?.payload?.error?.message
          ? e?.payload?.error?.message
          : 'There was an error';
        notifyError(message);
      },
    );
  };

  return (
    <Box>
      <SoundControlTitle>Sound Control</SoundControlTitle>
      <SoundControlDescription>
        Draw attention to new incidents by setting up notification sounds.
      </SoundControlDescription>
      <Box horizontal flow={10}>
        <SoundControlCard
          audioSettings={orgAudioSettings[ALERTS]}
          updateAudioSettings={updateAudioSettings}
        />
      </Box>
    </Box>
  );
};

export default SoundControl;
